<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              :placeholder="'Search here...'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="exportFile"
              v-if="allow('E')"
            >
              <b-icon-cloud-download></b-icon-cloud-download
              >{{ $l("INDEX.btn_export") || "导出" }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="900px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="130px">
        <el-row :gutter="20">
          <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
            <el-form-item
                :label="$l('form_label_scmName') || '供应商'"
                prop="scmCode"
              >
                <dict-select
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择...'"
                  clearable
                  filterable
                  v-model="form.scmCode"
                  size="small"
                  url="/digitalCenter/common/dict/scmInfoDict"
                ></dict-select>
              </el-form-item>
          </el-col>
          <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
            <el-form-item
                :label="$l('form_label_visitOwnerName') || '拜访人员'"
                prop="visitOwnerCode"
              >
                <dict-select
                  v-model="form.visitOwnerCode"
                  url="/digitalCenter/common/dict/baseUser"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择...'"
                  size="small"
                  filterable
                  clearable
                  :options="{ label: 'label', value: 'code' }"
                ></dict-select>
              </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
            <el-form-item
                :label="$l('form_label_depName') || '拜访业务部门'"
                prop="depCode"
              >
                <dict-select
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择...'"
                  clearable
                  filterable
                  v-model="form.depCode"
                  size="small"
                  url="/digitalCenter/common/dict/merchantDepartment"
                ></dict-select>
              </el-form-item>
          </el-col>
          <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
            <el-row>
              <el-form-item :label="$l('form_label_visitDate') || '拜访时间'">
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.visitDateStart"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_placeholder') || '请选择...'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.visitDateEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_placeholder') || '请选择...'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: {...initForm},
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 普通查询
    query({isReset = true} = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = {...initForm}
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    //导出数据
    exportFile() {
      let url = '/digitalCenter/scmInfoVisit/exportScmInfoVisit'
      let fileName = '供应商拜访记录统计导出'
      this.$api.globalExportData(url, this.form, fileName)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
